import React from "react";
import { Container } from "react-bootstrap";

export const Locations: React.FC = () => {

    return(
        <React.Fragment>
            <Container fluid className="p-0">
                Locations
            </Container>
        </React.Fragment>
    );
}